import { render, staticRenderFns } from "./EditResourceInformationModal.vue?vue&type=template&id=ef913ac6&scoped=true"
import script from "./EditResourceInformationModal.vue?vue&type=script&lang=ts"
export * from "./EditResourceInformationModal.vue?vue&type=script&lang=ts"
import style0 from "./EditResourceInformationModal.vue?vue&type=style&index=0&id=ef913ac6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef913ac6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef913ac6')) {
      api.createRecord('ef913ac6', component.options)
    } else {
      api.reload('ef913ac6', component.options)
    }
    module.hot.accept("./EditResourceInformationModal.vue?vue&type=template&id=ef913ac6&scoped=true", function () {
      api.rerender('ef913ac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/EditResourceInformationModal.vue"
export default component.exports